import { render, staticRenderFns } from "./date-strip.vue?vue&type=template&id=c9bef5f8&"
import script from "./date-strip.vue?vue&type=script&lang=js&"
export * from "./date-strip.vue?vue&type=script&lang=js&"
import style0 from "./date-strip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VSlideGroup,VSlideItem})
